import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';

import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Text, TextType } from 'ui-components/components/text';

import '../../../prop-types/add-on.types';
import { getUpsellModalContent } from '../../../components/upsell-modal/helper';
import Global from '../../../store/global-selectors';

import { ActivateAddOnModalQueryParam, AddOnCodeQueryParam } from '../../settings/add-on-marketplace/constants';
import messages from '../messages';
import style from './style.module.less';

/**
 * @param {object} props
 * @param {AddOnPropType} props.addOn
 * @returns {JSX.Element}
 */
export const TileToLinkToAddOns = ({ addOn }) => {
  const { allPlans } = useSelector(Global.selectSellerSubscriptionData);

  const { code } = addOn;

  const { name, description, icon } = getUpsellModalContent(code);

  const linkToOpenAddOnActivationModal = `/settings/addonmarketplace?${ActivateAddOnModalQueryParam}=true&${AddOnCodeQueryParam}=${code}`;
  const isIncludedInHighVolumePlan = allPlans?.some(
    (plan) =>
      !!plan?.subscriptionLineItems.find((lineItem) => lineItem.featureIds[0] === addOn.code) &&
      plan.code.toLowerCase().includes('highvolume'),
  );

  return (
    <div className={style['addon-card']}>
      <div>
        <div className={style['addon-header']}>
          <div className={style['addon-image']}>
            <img alt={code} src={icon} />
          </div>
          <div className={style['addon-content']}>
            <div className={style['addon-title']}>
              <Text textType={TextType.Label} value={name} />
            </div>
          </div>
        </div>
        <Text className={style.description} textType={TextType.Caption} value={description} />
        {isIncludedInHighVolumePlan ? (
          <Text className={style['included-in-high-volume']} textType={TextType.Caption} value={messages.includedInHighVolume} />
        ) : null}
      </div>
      <Link className={style['link-to-add-on-marketplace']} to={linkToOpenAddOnActivationModal}>
        <Text textType={TextType.Paragraph} value={messages.checkItOut} />
        <FontAwesomeIcon className={style['link-right-arrow']} icon={faArrowRight} />
      </Link>
    </div>
  );
};
